import { useId } from 'react';

import {
  ChipFilter,
  ChipGroup,
  Flex,
  Text,
} from '@spotify-internal/encore-web';
import { useFormField } from '@spotify/confidence-core-react';

import { SURVEY_ROLE_OPTIONS } from '../../config/onboardingSurvey';
import {
  OTHER_ROLE,
  type SurveyFormValues,
  type SurveyRoleSelection,
} from './surveyForm';

const ROLE_SELECTIONS: ReadonlyArray<{
  value: SurveyRoleSelection;
  label: string;
}> = [...SURVEY_ROLE_OPTIONS, { value: OTHER_ROLE, label: 'Something else' }];

export const RoleFormField = () => {
  const headingId = useId();
  const { value, setValue } = useFormField<SurveyFormValues, 'role'>('role');

  return (
    <Flex direction="column" gap="tighter">
      <Flex gap="tighter" alignItems="baseline" wrap="wrap">
        <Text as="h2" variant="bodyMediumBold" id={headingId}>
          What do you do for work?
        </Text>
        <Text as="span" variant="bodySmall" semanticColor="textSubdued">
          Choose your primary role
        </Text>
      </Flex>
      <ChipGroup
        aria-labelledby={headingId}
        layout="multi-line"
        mode="single-select"
      >
        {ROLE_SELECTIONS.map(option => (
          <ChipFilter
            key={option.value}
            type="button"
            size="small"
            isSelected={value === option.value}
            onClick={() => setValue(option.value)}
           data-track-source-anchor="4cf030f1b8;role-form-field-chip-filter">
            {option.label}
          </ChipFilter>
        ))}
      </ChipGroup>
    </Flex>
  );
};
